import React from "react";

import Image from "next/image";

import { PortableText } from "@portabletext/react";
import { customRichTextComponent } from "@/sanity/sanityPortableText";

import { PageManifestoSchema } from "@/sanity/pages/PageManifestoTemplate";

import signature from "@/public/manifesto/signature.svg";
import stamp from "@/public/manifesto/stamp.png";
import arrowDown from "@/public/manifesto/arrow-down-icon.svg";

export default function Motto({ data }: { data: PageManifestoSchema }) {
  return (
    <section className="lg:mt-[-32rem] mt-[5rem] overflow-clip">
      <div className="w-full max-w-[111rem] mx-auto px-[2rem] lg:px-0">
        {/*  */}
        <div className="w-fit flex justify-center items-center gap-[2rem] px-[4rem] pb-[1.5rem] pt-[2rem] bg-[#D9F9B9] relative">
          {/* right bottom border */}
          <div
            className="absolute top-0 right-0 w-[2rem] h-[2rem] bg-[#F3F2F1]"
            style={{
              clipPath: "polygon(100% 0, 0 0, 100% 100%)",
            }}
          ></div>
          {/* end right bottom border */}
          <Image
            src={arrowDown}
            alt="arrow"
            className="w-[2rem] min-w-[2rem]"
          />
          <span className="font-geistmono text-black text-[2rem] font-[400] leading-[100%] uppercase">
            {data?.settings?.language === "en" ? "Our Motto" : "Unser Motto"}
          </span>
        </div>
        {/*  */}

        <div className="w-full bg-white p-[3rem] lg:p-[7rem] border-t-[.75rem] border-t-[#D9F9B9] relative z-[1]">
          {data?.mottoTexts && (
            <PortableText
              value={data?.mottoTexts ?? []}
              components={customRichTextComponent({
                block: {
                  h2: ({ children }) => (
                    <h2 className="font-funnel text-black text-[4.5rem] lg:text-[6rem] leading-[100%] font-[500] mb-[2rem]">
                      {children}
                    </h2>
                  ),
                  normal: ({ children }) => (
                    <p className="text-black/60 font-[400] leading-[150%] mb-0 text-[2.25rem] min-h-[1lh]">
                      {children}
                    </p>
                  ),
                },
                marks: {
                  strong: ({ children }) => (
                    <span className="text-black">{children}</span>
                  ),
                },
              })}
            />
          )}

          <hr className="w-full border-[#202223]/20 my-[3rem]" />

          <div className="w-full flex justify-between items-end">
            <div className="flex flex-col pb-[2rem]">
              <Image
                src={signature}
                alt="signature"
                className="w-[22rem] min-w-[22rem] mb-[-2rem]"
              />
              <span className="font-geistmono text-black/50 font-[400] leading-[100%] text-[2.25rem] uppercase ps-[2rem]">
                CEO {data?.settings?.language === "en" ? "at" : "bei"} Trademania
              </span>
            </div>

            <Image
              src={stamp}
              alt="stamp"
              className="w-[19rem] min-w-[19rem] lg:w-[28rem] lg:min-w-[28rem] lg:mt-[-10rem]"
            />
          </div>
        </div>
      </div>

      {/* lines */}
      <div className="h-[.375rem] min-h-[.375rem] flex flex-col w-[179rem] min-w-[179rem] mx-auto overflow-clip lg:mt-[10rem] mt-[2rem]">
        <span className="w-full min-w-full h-[.125rem] min-h-[.125rem] bg-[#202223]/20"></span>
        <span className="w-full min-w-full h-[.25rem] min-h-[.25rem] bg-white"></span>
      </div>
      {/* end lines */}
    </section>
  );
}
